<script>
  import { createEventDispatcher } from "svelte";
  import { onMount } from "svelte";
  import Rhythm from "./logical_pattern/Rhythm.js";

  export let juggler;
  export let position;

  const dispatch = createEventDispatcher();

  let id;
  let name;
  let rhythm;
  let delay;
  let lookX;
  let lookY;
  let lookZ;
  let posX;
  let posY;
  let posZ;

  function reload() {
    id = juggler.id;
    name = juggler.name;
    rhythm = juggler.rhythm.toString();
    delay = juggler.delay;
    lookX = juggler.lookAt ? juggler.lookAt[0] : 0;
    lookY = juggler.lookAt ? juggler.lookAt[1] : 0;
    lookZ = juggler.lookAt ? juggler.lookAt[2] : 0;
    posX = juggler.position ? juggler.position[0] : 0;
    posY = juggler.position ? juggler.position[1] : 0;
    posZ = juggler.position ? juggler.position[2] : 0;
  }

  $: if (juggler) reload();

  onMount(reload);

  const rhythms = Rhythm.options;

  function handleKeydown(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleSave();
    } else if (event.key === 'Escape') {
      event.preventDefault();
      handleCancel();
    }
  }

  function handleSave() {
    dispatch("save", {
      ...juggler,
      name,
      rhythm: new Rhythm(rhythm),
      delay,
      lookAt: [lookX, lookY, lookZ],
      position: [posX, posY, posZ],
    });
  }

  function handleCancel() {
    dispatch("cancel");
  }
</script>

<div class="juggler-edit-box" style="position: absolute; top: {position.y}px; left: {position.x}px;">
  <label for="juggler-name">Name (ID {id}):</label>
  <input type="text" id="juggler-name" bind:value={name} on:keydown={handleKeydown} /><br />

  <label for="juggler-rhythm">Rhythm:</label>
  <select id="juggler-rhythm" bind:value={rhythm}>
    {#each rhythms as rhythmOption}
      <option value={rhythmOption.toString()}>
        {rhythmOption.toString()}
      </option>
    {/each}
  </select><br />

  <label for="juggler-delay">Delay:</label>
  <input type="number" id="juggler-delay" bind:value={delay} on:keydown={handleKeydown} /><br />

  <label for="juggler-pos-x">Position:</label>
  <input type="number" id="juggler-pos-x" bind:value={posX} on:keydown={handleKeydown} placeholder="X" /> ,
  <input type="number" id="juggler-pos-y" bind:value={posY} on:keydown={handleKeydown} placeholder="Y" /> ,
  <input type="number" id="juggler-pos-z" bind:value={posZ} on:keydown={handleKeydown} placeholder="Z"/><br />

  <label for="juggler-look-x">Look At:</label>
  <input type="number" id="juggler-look-x" bind:value={lookX} on:keydown={handleKeydown} placeholder="X" /> ,
  <input type="number" id="juggler-look-y" bind:value={lookY} on:keydown={handleKeydown} placeholder="Y" /> ,
  <input type="number" id="juggler-look-z" bind:value={lookZ} on:keydown={handleKeydown} placeholder="Z"/><br />

  <button on:click={handleSave}>Save</button>
  <button on:click={handleCancel}>Cancel</button>
</div>

<style>
  .juggler-edit-box {
    font-size: 25px;
    border-radius: 10px;
    border: 4px solid black;
    padding: 10px;
    background-color: white;
    z-index: 100; /* Ensure it's on top */
  }

  .juggler-edit-box label {
    display: inline-block;
    font-size: 25px;
    margin: 5px;
    width: 140px;
  }

  .juggler-edit-box input, .juggler-edit-box button, .juggler-edit-box select {
    font-size: 25px;
    margin: 5px;
  }

  .juggler-edit-box input {
    border: 1px solid #ddd;
  }

  .juggler-edit-box button {
    margin-top: 10px;
    margin-right: 10px;
  }

  #juggler-delay, #juggler-name {
    width: calc(100% - 180px);
  }
</style>
